exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page[data-v-1830256a] {\n  width: 10rem;\n  height: 100%;\n  background: #fff;\n}\n.page .content .separator[data-v-1830256a] {\n  width: 100%;\n  height: 0.266667rem;\n  background: #fafafa;\n}\n.page .call[data-v-1830256a] {\n  position: absolute;\n  bottom: 2.573333rem;\n  left: 3.666667rem;\n}\n.page .call-tips[data-v-1830256a] {\n  font-size: 0.32rem;\n  font-family: PingFangSC-Regular, PingFang SC;\n  font-weight: 400;\n  color: #999999;\n  line-height: 0.44rem;\n  position: absolute;\n  bottom: 1.866667rem;\n  left: 3.4rem;\n}", ""]);

// exports
